import { render, staticRenderFns } from "./wallet-list.vue?vue&type=template&id=01436c50"
import script from "./wallet-list.vue?vue&type=script&lang=js"
export * from "./wallet-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports